import React, { Component } from 'react';

import { translate } from 'components/translate';
import { fabric } from 'fabric';
import { DatahubCertificateService } from 'modules/app/services/datahub/certificate';
import PropTypes from 'prop-types';

import QRCodeSVG from './assets/qr-code.png';

import { CERTIFICATE_KEY, TEXT_CONFIGS } from '../constants';
import { getMergedTags } from '../helpers/getMergedTags';
import CanvasMenuSelect from '../menu/CanvasMenuSelect';

@translate()
export default class CanvasMergedTags extends Component {
  static propTypes = {
    canvasRef: PropTypes.object,
    onUpdate: PropTypes.func,
    tag: PropTypes.object,
    actualTag: PropTypes.object,
    t: PropTypes.func,
    isQrCodeEnabled: PropTypes.bool,
    onAddQrCode: PropTypes.func
  };

  addText(value = '', options) {
    const { canvasRef } = this.props;
    const text = new fabric.IText(value, { ...options });

    canvasRef.add(text);
    canvasRef.renderAll();
    canvasRef.setActiveObject(text);
  }

  getMousePosition(event) {
    const top = event.pointer ? event.pointer.y : 0;
    const left = event.pointer ? event.pointer.x : 0;

    return { top, left };
  }

  createText(event) {
    const { actualTag, t } = this.props;
    const { top, left } = this.getMousePosition(event);
    const canvas = event.e.target;
    const maxCanvasLeft = canvas.width - TEXT_CONFIGS.PADDING_TEXT_POSITION;
    const mediumTagLength =
      TEXT_CONFIGS.MEDIUM_LETTER_WIDTH * actualTag.label.length;
    const maxElementLeft = maxCanvasLeft - mediumTagLength;
    const options = {
      top,
      left: Math.min(left, maxElementLeft),
      lockScalingY: true,
      lockScalingX: true,
      editable: false,
      cursorWidth: 0,
      fontSize: TEXT_CONFIGS.INITIAL_FONT_SIZE,
      mergedTag: `*|${actualTag.value}|*`
    };
    const translatedLabel = `*|${t(`certificate.${actualTag.label}`)}|*`;

    this.addText(translatedLabel, options);
    this.disableClickEvent();
  }

  createQRCode = () => {
    const { canvasRef, onAddQrCode } = this.props;

    DatahubCertificateService.sendQRCodeEvent();

    fabric.Image.fromURL(QRCodeSVG, (img) => {
      const qrCodeImg = img.set({
        left: 609,
        top: 400,
        lockScalingY: true,
        lockScalingX: true,
        editable: false,
        cursorWidth: 0
      });

      canvasRef.add(qrCodeImg);
      canvasRef.renderAll();
      canvasRef.setActiveObject(qrCodeImg);

      this.disableClickEvent();

      onAddQrCode?.();
    });
  };

  setCursor(cursor = 'default') {
    const { canvasRef } = this.props;

    canvasRef.defaultCursor = cursor;
  }

  enableClickEvent(func) {
    const { canvasRef } = this.props;

    this.setCursor('crosshair');
    canvasRef.on('mouse:down', func);
  }

  disableClickEvent() {
    const { canvasRef } = this.props;

    canvasRef.off('mouse:down');
  }

  createMergedTag(option) {
    const { onUpdate, canvasRef } = this.props;

    canvasRef.off('mouse:down');

    onUpdate(option);

    if (option.value === CERTIFICATE_KEY.QR_CODE) {
      this.enableClickEvent(this.createQRCode.bind(this));
    } else {
      this.enableClickEvent(this.createText.bind(this));
    }
  }

  get translateMergedTag() {
    const { t, isQrCodeEnabled } = this.props;

    const avaibleTag = getMergedTags(isQrCodeEnabled);

    avaibleTag.forEach((option) => {
      if (option.label === option.key) {
        option.label = t(`certificate.${option.label}`);
        option.value = option.key;
      }
    });

    return avaibleTag;
  }

  render() {
    const avaibleTag = this.translateMergedTag;
    const { tag, t } = this.props;

    return (
      <CanvasMenuSelect
        onChange={this.createMergedTag.bind(this)}
        options={avaibleTag}
        value={tag?.value || ''}
        placeholder={t('canvas-editor.text.tags')}
        toolTip="canvas-editor.text.tags"
        className="canvas-menu__select-tags"
      />
    );
  }
}
